// Libraries
import React, { useContext } from 'react';

// Services and Contexts
import LanguageContext from '../contexts/LanguageContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function ScreenInfo({ title, description }) {
  const { translate } = useContext(LanguageContext);
  const translation = translate(description);
  const theme = useTheme();
  const breakPoint = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box textAlign="left" p={4} mt={breakPoint ? 0 : -2}>
      <Box>
        <Typography variant="h5" align="left" gutterBottom>
          <strong>{translate(title)}</strong>
        </Typography>
      </Box>

      {Array.isArray(translation) ? (
        translation.map((paragraph, index) => (
          <Typography key={index} variant="body1" paragraph>
            {paragraph}
          </Typography>
        ))
      ) : (
        <Typography variant="body1" paragraph>
          {translation}
        </Typography>
      )}
    </Box>
  );
}
